export const MODEL_ROUTE = '/users';
